var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileoTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.25) scale(0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 95.5312C202 62.6531 228.654 36 261.531 36C294.408 36 321.062 62.6531 321.062 95.5312C321.062 128.409 294.408 155.062 261.531 155.062C228.654 155.062 202 128.409 202 95.5312Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 67.5C27 30.2208 57.222 0 94.5 0C131.778 0 162 30.2208 162 67.5C162 104.779 131.778 135 94.5 135C57.222 135 27 104.779 27 67.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.52 135.219C347.52 102.341 374.174 75.6875 407.051 75.6875C439.928 75.6875 466.582 102.341 466.582 135.219C466.582 168.097 439.928 194.75 407.051 194.75C374.174 194.75 347.52 168.097 347.52 135.219Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 201.363C202 190.404 210.885 181.52 221.844 181.52H314.448C325.407 181.52 334.292 190.404 334.292 201.363V293.967C334.292 341.458 295.792 379.957 248.302 379.957H221.844C210.885 379.957 202 371.072 202 360.113C202 349.154 210.885 340.27 221.844 340.27H248.302C273.874 340.27 294.604 319.539 294.604 293.967V221.207H221.844C210.885 221.207 202 212.322 202 201.363Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 187.5C39 175.074 49.074 165 61.5 165H166.5C178.926 165 189 175.074 189 187.5V292.5C189 346.347 145.347 390 91.5 390L60 378C47.574 378 34 357.426 34 345C34 332.574 49.074 345 61.5 345H91.5C120.495 345 144 321.495 144 292.5V210H61.5C49.074 210 39 199.926 39 187.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147 187.5C147 175.074 137.127 165 124.95 165H22.05C9.87254 165 1.52588e-05 175.074 1.52588e-05 187.5V292.5C1.52588e-05 346.347 42.7799 390 95.55 390L135.5 374.5C147.677 374.5 152 359.926 152 347.5C152 335.074 137.127 345 124.95 345H95.55C67.1349 345 44.1 321.495 44.1 292.5V210H124.95C137.127 210 147 199.926 147 187.5Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.52 241.051C347.52 230.092 356.404 221.207 367.363 221.207H459.967C470.926 221.207 479.811 230.092 479.811 241.051V293.967C479.811 341.458 441.312 379.957 393.822 379.957H367.363C356.404 379.957 347.52 371.072 347.52 360.113C347.52 349.154 356.404 340.27 367.363 340.27H393.822C419.394 340.27 440.124 319.539 440.124 293.967V260.895H367.363C356.404 260.895 347.52 252.01 347.52 241.051Z",
    fill: "#222222"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileoTeams);
export default __webpack_public_path__ + "static/media/mobileoTeams.398b808d.svg";
export { ForwardRef as ReactComponent };